<template>
    <div class>
        <div slot="header" class="clearfix" style="background-color:#F2F2F2; padding: 20px;">
            <span style="font-weight:600;color:#000; line-height: 10px;">机构信息</span>
        </div>
        <el-form :model="form" ref="form" :rules="rules" label-width="130px" style="width: 450px; margin-top: 20px;">
          <el-form-item label="机构名称" prop="name">
              <el-input
              v-model="form.name"
              placeholder="请输入机构名称"
              ></el-input>
          </el-form-item>
          <el-form-item label="机构注册地址" prop="address">
              <el-input v-model="form.address" placeholder="请输入机构注册地址"></el-input>
          </el-form-item>


          <el-form-item label="统一社会信用代码" prop="code">
              <el-input v-model="form.code" placeholder="请输入统一社会信用代码"></el-input>
          </el-form-item>
        </el-form>
      <div slot="header" class="clearfix" style="background-color:#F2F2F2; padding: 20px;">
        <span style="font-weight:600;color:#000; line-height: 10px;">联系信息</span>
      </div>
        <el-form :model="form" ref="secondForm" :rules="rules" label-width="130px" style="width: 450px; margin-top: 20px;">
          <el-form-item label="联系人" prop="contactUser">
            <el-input v-model="form.contactUser" placeholder="请输入联系人"></el-input>
          </el-form-item>
          <el-form-item label="联系方式" prop="contactNum">
            <el-input v-model="form.contactNum" placeholder="请输入联系方式"></el-input>
          </el-form-item>
          <el-form-item label="联系地址" prop="contactAddress">
            <el-input v-model="form.contactAddress" placeholder="请输入联系地址"></el-input>
          </el-form-item>
          <el-form-item label="联系邮箱" prop="email">
            <el-input v-model="form.email" placeholder="请输入联系邮箱"></el-input>
          </el-form-item>
          <el-form-item label="备注说明" prop="remark">
            <el-input v-model="form.remark" type="textarea" placeholder="请输入备注说明"></el-input>
          </el-form-item>
          <el-form-item style="display:flex;flex-direction: column;text-align: center;">
            <el-button @click="cancel" class="resetbtn">取消</el-button>
            <el-button type="success" @click="onSubmit(true)">保存</el-button>
          </el-form-item>
        </el-form>
    </div>
</template>

  <script>
  import { regionData ,provinceAndCityData} from "element-china-area-data";
  import { HOST, EV_HOST } from "@/utils/host";
  export default {
    name: "xinzengyunyingshang",
    components: {},
    data() {
      return {
        optionsThree: regionData, //省市区数据
        form: {
          orgType: 0,
          attr: 0,
          type: "sys",
          businessLicense: "",
          stationLogo: "",
          platformLogo: "",
          operatorName: "",
          creatTime: [],
          invoice: false
        },
        rules: {
          name: [
            { required: true, message: '请输入机构名称', trigger: 'blur' },
          ],
          address: [
            { required: true, message: '请输入机构注册地址', trigger: 'blur' },
          ],
          code: [
            { required: true, message: '请输入统一社会信用代码', trigger: 'blur' },
          ],
          contactUser: [
            { required: true, message: '请输入联系人', trigger: 'blur' },
          ],
          contactNum: [
            { required: true, message: '请输入联系方式', trigger: 'blur' },
          ],
          contactAddress: [
            { required: true, message: '请输入联系地址', trigger: 'blur' },
          ],
          email: [
            { required: true, message: '请输入联系邮箱', trigger: 'blur' },
          ],
        },
        imageUrl: "",
        imageUrl1: "",
        imageUrl2: "",
        isShow0: true, //0显示
        isShow1:false, //1显示
        isShow2:false, //2显示
        isShow3: false,//3显示
      };
    },
    computed: {
      headers() {
        return {
          token: window.localStorage.getItem("token")
        };
      },
      action() {
        return HOST + "/oss";
      }
    },
    methods: {
      async onSubmit(flag) {
        try {
            //必填校验
            await Promise.all([
                this.$refs.form.validate(),
                this.$refs.secondForm.validate(),
            ]);
        } catch (error) {
            return;
        }

        if (!flag) {
          this.$router.go(-1)
          return;
        }
        if (this.form.creatTime != []) {
          this.form.signStartTime = this.form.creatTime[0]
          this.form.signEndTime = this.form.creatTime[1]
        } else {
          this.form.signStartTime = ""
          this.form.signEndTime = ""
        }
        if(this.form.city && this.form.city != '') {
          this.form.city = this.form.city.join(",");
          this.form.cityName = this.$refs.three.getCheckedNodes()[0].pathLabels.join(" / ");
        } else {
          this.form.city = '';
          this.form.cityName = '';
        }
        let data = {
          name:this.form.name,
          orgType: this.form.orgType,
          loginName:"",
          userName:"",
          password:"",
          userPhone:"",
          attr: this.form.attr,
          operatorName: this.form.operatorName,
          prefix:this.form.prefix,
          address:this.form.address,
          code:this.form.code,
          city:this.form.city,
          cityName:this.form.cityName,
          signStartTime:this.form.signStartTime,
          signEndTime:this.form.signEndTime,
          contactUser:this.form.contactUser,
          contactNum:this.form.contactNum,
          contactAddress:this.form.contactAddress,
          email:this.form.email,
          businessLicense: this.form.businessLicense,
          stationLogo: this.form.stationLogo,
          platformLogo: this.form.platformLogo,
          remark:this.form.remark,
          type:"sys"
        }
        console.log(data,'dataa')
        this.$store.dispatch("form/handle", {
          url: "/org",
          data: data,
          method: "put",
          callback: resp => {
            console.log(resp)
            this.$notify({
              title: "成功",
              message: "新增成功",
              type: "success"
            });
            this.$router.go(-1);
            this.$store.dispatch("login/getCur")
            this.$store.dispatch("login/getMenu")
          }
        });
      },
      cancel(){
        this.$router.go(-1)
      },
      handleAvatarSuccess(res, file) {
        this.imageUrl = URL.createObjectURL(file.raw);
        this.form.businessLicense = res.data.fileName;
      },
      handleRemove(){
        this.imageUrl = ''
        this.form.businessLicense = '';
      },
      handleAvatarSuccess1(res, file) {
        this.imageUrl1 = URL.createObjectURL(file.raw);
        this.form.stationLogo = res.data.fileName;
      },
      handleRemove1(){
        this.imageUrl1 = ''
        this.form.stationLogo = '';
      },
      handleAvatarSuccess2(res, file) {
        this.imageUrl2 = URL.createObjectURL(file.raw);
        this.form.platformLogo = res.data.fileName;
      },
      handleRemove2(){
        this.imageUrl2 = ''
        this.form.platformLogo = '';
      },
      beforeAvatarUpload(file) {
        const isJPG = (file.type === 'image/jpeg' || file.type === 'image/jpg' || file.type === 'image/png');
        const isLt2M = file.size <= 2097152;

        if (!isJPG) {
          this.$message.error("上传图片只能是 JPG/JEPG/PNG 格式!");
        }
        if (!isLt2M) {
          this.$message.error("上传图片大小不能超过 2MB!");
        }
        return isJPG && isLt2M;
      },

      isSelect(val) {
        console.log(val)
        if (val === 0) {
          this.isShow0 = true
          this.isShow3 = false
          this.form.prefix = ""
        } else if (val === 1) {
          this.isShow3 = true
          this.isShow0 = false
        } else if (val === 2) {
          this.isShow0 = false
          this.isShow3 = false
          this.isShow = true
        } else if(val === 3){
          this.isShow3 = true
          this.isShow0 = true
        }
      }
    },
    mounted() {},
    beforeCreate() {}, //生命周期 - 创建之前
    beforeMount() {}, //生命周期 - 挂载之前
    beforeUpdate() {}, //生命周期 - 更新之前
    updated() {}, //生命周期 - 更新之后
    beforeDestroy() {}, //生命周期 - 销毁之前
    destroyed() {}, //生命周期 - 销毁完成
    activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
  };
  </script>

  <style lang="less" src="" scoped>
  .avatar-uploader /deep/ .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }

  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
  .el-upload__tip{
    color: #409EFF;
  }

  .el-upload-action {
  position: absolute;
  top: 0;
  left: 0;
  display: block;
  width: 100%;
  height: 100%;
  font-size: 0;
  color: #fff;
  text-align: center;
  line-height: 178px;

}
.el-upload-action:hover {
  font-size: 20px;
  background-color: #000;
  background-color: rgba(0, 0, 0, .3)
}
.resetbtn:hover {
  border: 1px solid #00cc00;
  color: #00cc00
}
.resetbtn:active {
  border: 1px solid #00cc00;
  color: #ffffff;
  background-color:#00cc00;
}
  </style>



// WEBPACK FOOTER //
// src/views/BMS/organManagement/addOperatormanagement.vue